import React from "react";
import { Link } from "react-router-dom";
import donateImg from "../Assets/barImg.png";

const DonateBar = () => {
  return (
    <div className='bg-black'>
      <div className='relative w-screen h-[12rem] lg:h-[15rem]'>
        {/* <img
          src={donateImg}
          alt=''
          className='opacity-40 h-[10rem] object-cover w-screen'
        /> */}

        <div className='absolute top-0 w-full h-full  '>
          <div className='flex w-full h-full items-center justify-between px-4 md:container md:mx-auto lg:px-24'>
            <div className='flex flex-col'>
              {/* <h1 className='text-white text-4xl font-semibold'>OPC</h1> */}
              <h1 className='font- font-light text-xl slg:text-4xl text-white'>
                Empowering Regenerative Leaders Through Our Educational Centers
              </h1>
            </div>

            <button>
              <Link to={`/donate`} className='bg-green-600 hover:scale-95 transition duration-500 ease-in-out text-white font-bold px-8 md:px-11 py-3 flex items-center'>
                <h1 className='border-b-2 border-black w-8 mx-2'></h1>
                <h1 className='text-black'>Donate</h1>
              </Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonateBar;
